/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component for showing a simple dialogs
 *
 * @vue-prop {String} title dialog title
 * @vue-prop {String} text dialog text or html
 * @vue-prop {Array} buttons buttons to show in footer
 *
 * @category ui.components.modals
 * @exports Dialog
 */

import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';

const __vue_script__ = {
    name: 'DialogComponent',

    components: {
        LoaderButton,
    },

    props: {
        title: {
            type: String,
            default: ''
        },

        text: {
            type: String,
            default: ''
        },

        alert: {
            type: String,
            default: null
        },

        closeOnHeader: {
            type: Boolean,
            default: false
        },

        buttons: {
            type: Array,
            default: () => ([])
        },

        classes: {
            type: String,
            default: 'dialog'
        }
    },

    methods: {
        click(i, event) {
            const button = this.buttons[i];
            if (!button) {
                return;
            }
            if (button.closeOnClick) {
                this.$emit('close');
            }
            if (typeof button.handler === 'function') {
                button.handler(i, event);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-wrapper", class: _vm.classes }, [
    _vm.title
      ? _c("div", { staticClass: "modal-header" }, [
          _vm.closeOnHeader
            ? _c("span", {
                staticClass: "close",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              })
            : _vm._e(),
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "modal-body" }, [
      _c("div", {
        staticClass: "content",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _vm.alert
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _vm._v(_vm._s(_vm.alert)),
          ])
        : _vm._e(),
    ]),
    _vm.buttons.length
      ? _c(
          "div",
          { staticClass: "modal-footer" },
          _vm._l(_vm.buttons, function (button, i) {
            return _c(
              "loader-button",
              {
                key: i,
                class: button.class || "btn btn-default",
                attrs: { disabled: !!button.loading, status: !!button.loading },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.click(i, $event)
                  },
                },
              },
              [_vm._v(_vm._s(button.title))]
            )
          }),
          1
        )
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/modals/DialogComponent.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__